import React from "react";
import { Grid, Typography } from "@material-ui/core";
import FabButton from "@icarius-common/fabButton";

const NoData = ({ title, createTitle, onClick }) => {

    return (
        <Grid container alignItems="center" justify="center" direction="column" style={{ marginTop: 150 }}>
            <Typography color="textSecondary" className="whiteText" variant="h2" style={{ fontSize: 32, fontWeight: 700, marginBottom: 16 }}>
                {title}
            </Typography>
            <div style={{ marginTop: 30 }}>
                <FabButton
                    ignoreIcon
                    useColorBackground
                    useWhiteTextAlways
                    onClick={onClick}
                    title={createTitle}
                />
            </div>
        </Grid>
    )
}

export default NoData;